import { render, staticRenderFns } from "./nbn-edit-form.vue?vue&type=template&id=09725d71&scoped=true"
import script from "./nbn-edit-form.vue?vue&type=script&lang=js"
export * from "./nbn-edit-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09725d71",
  null
  
)

export default component.exports